import { createSelector } from "reselect"
import { ISibling, ISmartLocation } from "./index"

const getSiblings = (state: ISmartLocation): ISibling[] =>
    state.siblings?.siblingsContent ?? []

export interface SortedSiblingsByEditable {
    editableSiblings: ISibling[]
    notEditableSiblings: ISibling[]
}

export const getSortedSiblingsByEditable = createSelector(
    [getSiblings],
    (siblings): SortedSiblingsByEditable => {
        const editableSiblings: ISibling[] = []
        const notEditableSiblings: ISibling[] = []

        if (!!siblings) {
            siblings.forEach((sibling) => {
                sibling.type = getSiblingType(sibling.Url)
                sibling.isCurrent = isCurrentSibling(sibling.Url)

                if (sibling.Editable) {
                    editableSiblings.push(sibling)
                    return
                }
                notEditableSiblings.push(sibling)
            })
        }

        return {
            editableSiblings,
            notEditableSiblings,
        }
    },
)

const isCurrentSibling = (url: string): boolean => {
    const pathname = window.location.pathname

    if (!url.includes("timesheet")) {
        return pathname.includes(url)
    }

    // check for "your timesheets"
    // if the current timesheet contains an id before the date then it's not our timesheet
    const regexp = /timesheet\/\d{4}\/\d{2}\/\d{2}$/

    return regexp.test(pathname) && url.endsWith("timesheet/")
        ? true
        : pathname.endsWith(url)
}

const getSiblingType = (url: string): string => {
    if (url.includes("cover")) {
        return "cover"
    } else if (url.includes("tutorial")) {
        return "tutorial"
    } else if (url.endsWith("f")) {
        return "smartlist"
    }
    return "list"
}
